import * as React from 'react';

import { ControlledInputPropsBase } from '../../common/InputControlProps';
import AppVersionInlineEditor from './AppVersionInlineEditor';
import AppVersionTag from './AppVersionTag';

interface AppVersionTagInputProps extends ControlledInputPropsBase<string> {
  disabled?: boolean;
  onClose?: () => void;
}

interface AppVersionTagInputState {
  editMode: boolean;
}

export class AppVersionTagInput extends React.Component<
  AppVersionTagInputProps,
  AppVersionTagInputState
> {
  state = { editMode: false };

  handleCancelEdit = () => {
    this.setState({
      editMode: false,
    });
  };

  handleClickOnTag = () => {
    this.setState({
      editMode: true,
    });
  };

  handleSubmit = (value) => {
    const { onChange } = this.props;
    this.setState({
      editMode: false,
    });
    onChange(value);
  };

  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { onChange, ...rest } = this.props;
    const { value } = this.props;
    const { editMode } = this.state;
    return (
      <div style={{ display: 'inline-block' }}>
        {editMode ? (
          <AppVersionInlineEditor
            initialValue={value}
            onSubmit={this.handleSubmit}
            onCancel={this.handleCancelEdit}
          />
        ) : (
          <AppVersionTag {...rest} onClick={this.handleClickOnTag} />
        )}
      </div>
    );
  }
}

export default AppVersionTagInput;
